import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { getPriceStr, pluralize } from 'utils';

export default ({ _id, picture, title, bedrooms, accommodates, reservation, query, small }) => {
  const src = picture.regular;
  const { basePrice, currency, fareAccommodation } = reservation;
  const href = `/listings/${_id}${query ? `?${query}` : ''}`;
  const price = fareAccommodation || basePrice;
  const className = cn("listing", "text-left", { "listing-small": small });
  return (
    <div className={className}>
      <Link to={href} className="unstyled-link d-block">
        <img src={src} alt={title} className="img-fluid mb-3"/>
        <div className="row mr-0 align-items-end no-gutters px-2 listing-info">
          <div className="col listing-info-column mr-2">
            <div className={cn("font-weight-bold", "listing-title", { "mb-15": small })}>{title}</div>
            <div>{accommodates} {pluralize('guest', accommodates)} | {bedrooms} {pluralize('bedroom', bedrooms)}</div>
          </div>
          <div className="col-auto">
            <div>&nbsp;</div>
            <div>From&nbsp;</div>
          </div>
          <div className={cn("col-auto", { "text-dense": !!small })}>
            <span className={cn("col-auto", {"text-tall": !small, "font-weight-normal": !!small })}>{getPriceStr(price, currency)}</span>
          </div>
        </div>
      </Link>
    </div>
  )
};


// WEBPACK FOOTER //
// ./src/components/common/Listing.js